// name of the constant = route name in lower case
import { deliveryList, fuelList } from '@common/constants/mdm';
import { vehicleTypeMode } from 'pando-constants';
import { packagingList } from './carton';
import { portTypes } from './port';
import { regulationList, transportationModeList } from './shipmethod';
import { unitOfMeasure } from './transportation-db';
import { gstList, msmeOptions, statusList } from './transporter';
import { hubType } from './transshipmentConstants';


const port = [
  { title: 'Name', tlabel: 'MDM_NAME', type: 'input', paramKey: 'name', required: true },
  { title: 'Ref ID', tlabel: 'MDM_REF_ID', type: 'input', paramKey: 'ref_id', required: true },
  { title: 'Short Code', tlabel: 'MDM_SHORT_CODE', type: 'input', paramKey: 'short_code', required: true },
  {
    title: 'PORT TYPE',
    type: 'dropdown',
    tlabel: 'MDM_PORT_TYPE',
    paramKey: 'type',
    options: portTypes,
    endGroup: true,
    required: true,
  },
  { title: 'City', tlabel: 'MDM_CITY', type: 'input', paramKey: 'city', required: true },
  { title: 'State', tlabel: 'MDM_STATE', type: 'input', paramKey: 'state', required: true },
  { title: 'Address', tlabel: 'MDM_ADDRESS', type: 'input', paramKey: 'address', required: true },
  { title: 'Country', tlabel: 'MDM_COUNTRY', type: 'input', paramKey: 'country', required: true },
  { title: 'GEO Code', tlabel: 'MDM_GEO_CODE', type: 'input', paramKey: 'geo_code' },
  { title: 'PINCODE', tlabel: 'MDM_PINCODE', type: 'input', paramKey: 'pin_code', required: true },
];

const cha = [
  { title: 'Name', tlabel: 'MDM_NAME', type: 'input', paramKey: 'name', required: true },
  { title: 'Reference ID', tlabel: 'MDM_REFERENCE_ID', type: 'input', paramKey: 'ref_id', required: true },
  { title: 'Pan number', tlabel: 'MDM_PAN_NUMBER', type: 'input', paramKey: 'pan_number' },
  {
    id: 'ports_associated',
    title: 'Ports associated',
    tlabel: 'MDM_PORTS_ASSOCIATED',
    type: 'MultiSelectList',
    paramKey: 'ports_associated',
    options: [],
    endGroup: true,
  },
  { title: 'GST number', tlabel: 'MDM_GST_NUMBER', type: 'input', paramKey: 'gst_number' },
  { title: 'Admin name', tlabel: 'MDM_ADMIN_NAME', type: 'input', paramKey: 'admin_name', required: true },
  { title: 'Email', tlabel: 'MDM_EMAIL', type: 'input', paramKey: 'email_id', required: true },
  { title: 'Mobile', tlabel: 'MDM_MOBILE', type: 'input', paramKey: 'mobile_no' },
];

const container = [
  { title: 'Name', tlabel: 'MDM_NAME', type: 'input', paramKey: 'name', required: true },
  { title: 'Reference ID', tlabel: 'MDM_REFERENCE_ID', type: 'input', paramKey: 'ref_id', required: true },
  { title: 'Capacity CFT', tlabel: 'MDM_CAPACITY_CFT', type: 'input', inputType: 'number', paramKey: 'capacity', required: true },
  {
    id: 'preferred_truck_type',
    title: 'Preferred truck type',
    tlabel: 'MDM_PREFERERED_TRUCK_TYPE',
    type: 'dropdown',
    paramKey: 'preferred_truck_type',
    endGroup: true,
  },
  { title: 'Tare weight(KG)', tlabel: 'MDM_TARE_WEIGHT_KG', type: 'input', inputType: 'number', paramKey: 'tare_weight', required: true },
  { title: 'Max gross weight(KG)', tlabel: 'MDM_MAX_GROSS_WEIGHT_KG', type: 'input', inputType: 'number', paramKey: 'max_gross_weight', required: true },
  { title: 'Max payload(KG)', tlabel: 'MDM_MAX_PAYLOAD_KG', type: 'input', inputType: 'number', paramKey: 'max_payload', endGroup: true, required: true },
  {
    title: 'Door Opening',
    type: 'subColumn',
    tlabel: 'MDM_DOOR_OPENING',
    paramKey: 'container_dimension_door_opening',
    subColumnCount: 3,
    endGroup: true,
    required: true,
    subColumns: [
      { title: 'Width (FT)', tlabel: 'MDM_WIDTH_FT', paramKey: 'width', inputType: 'number' },
      { title: 'Height (FT)', tlabel: 'MDM_HEIGHT_FT', paramKey: 'height', inputType: 'number' },
    ],
  },
  {
    title: 'Exterior',
    type: 'subColumn',
    tlabel: 'MDM_EXTERIOR',
    paramKey: 'container_dimension_exterior',
    subColumnCount: 3,
    endGroup: true,
    required: true,
    subColumns: [
      { title: 'Length (FT)', tlabel: 'MDM_LENGTH_FT', paramKey: 'length', inputType: 'number' },
      { title: 'Width (FT)', tlabel: 'MDM_WIDTH_FT', paramKey: 'width', inputType: 'number' },
      { title: 'Height (FT)', tlabel: 'MDM_HEIGHT_FT', paramKey: 'height', inputType: 'number' },
    ],
  },
  {
    title: 'Interior',
    type: 'subColumn',
    tlabel: 'MDM_INTERIOR',
    paramKey: 'container_dimension_interior',
    subColumnCount: 3,
    endGroup: true,
    required: true,
    subColumns: [
      { title: 'Length (FT)', tlabel: 'MDM_LENGTH_FT', paramKey: 'length', inputType: 'number' },
      { title: 'Width (FT)', tlabel: 'MDM_WIDTH_FT', paramKey: 'width', inputType: 'number' },
      { title: 'Height (FT)', tlabel: 'MDM_HEIGHT_FT', paramKey: 'height', inputType: 'number' },
    ],
  },
];

const freightforwarder = [
  { title: 'Company Name', tlabel: 'MDM_COMPANY_NAME', id: 'freightforwarder_name', type: 'dropdown', paramKey: 'id', options: [], required: true },
  { title: 'Govt ID(Pan No.)', tlabel: 'MDM_GOVT_ID_PAN_NUMBER', type: 'input', paramKey: 'govt_id', required: true, disabled: true, isdependent: true, ignore_field: true },
  { title: 'Reference Id', tlabel: 'MDM_REFERENCE_ID', type: 'input', paramKey: 'ref_id', required: true },
  { title: 'Status', tlabel: 'MDM_STATUS', type: 'switch', paramKey: 'status', required: true, active_text: 'ACTIVE', inactive_text: 'INACTIVE' },
  {
    title: 'Admin',
    tlabel: 'MDM_ADMIN',
    type: 'subColumn',
    subColumnCount: 3,
    paramKey: 'admin',
    endGroup: true,
    subColumns: [
      { title: 'Admin Name', tlabel: 'MDM_ADMIN_NAME', paramKey: 'admin_name', type: 'input', required: true, disabled: true, isdependent: true, ignore_field: true },
      { title: 'Admin Email', tlabel: 'MDM_ADMIN_EMAIL', paramKey: 'admin_email', type: 'input', required: true, disabled: true, isdependent: true, ignore_field: true },
      { title: 'Admin Phone', tlabel: 'MDM_ADMIN_PHONE', paramKey: 'admin_phone', type: 'input', inputType: 'number', required: true, disabled: true, isdependent: true, ignore_field: true },
    ],
  },
];

const carton = [
  { title: 'Code', tlabel: 'MDM_CODE', type: 'input', paramKey: 'code', required: true },
  // { title: 'Packaging',
  //   type: 'dropdown',
  //   paramKey: 'packaging_code',
  //   options: packagingList,
  //   required: true,
  // },
  { title: 'Packaging', tlabel: 'MDM_PACKAGING', type: 'dropdown', paramKey: 'packaging_code', options: packagingList, required: true },
  { title: 'Description', tlabel: 'MDM_DESCRIPTION', type: 'input', paramKey: 'description', required: true },
  { title: 'Weight', tlabel: 'MDM_WEIGHT', type: 'input', paramKey: 'weight_kg', required: true },
  { title: 'Volume', tlabel: 'MDM_VOLUME', type: 'input', paramKey: 'volume_ltr', required: true },
  { title: 'Length', tlabel: 'MDM_LENGTH', type: 'input', paramKey: 'length_cm', required: true },
  { title: 'Width', tlabel: 'MDM_WIDTH', type: 'input', paramKey: 'width_cm', required: true },
  { title: 'Height', tlabel: 'MDM_HEIGHT', type: 'input', paramKey: 'height_cm', required: true },
];

const carrier = [
  { title: 'Code', tlabel: 'MDM_CODE', type: 'input', paramKey: 'code', required: true },
  { title: 'Service', tlabel: 'MDM_SERVICE', type: 'input', paramKey: 'service', required: true },
  { title: 'Description', tlabel: 'MDM_DESCRIPTION', type: 'input', paramKey: 'description', required: true },
];

const vehicledetail = [
  { title: 'Vehicle Number', tlabel: 'MDM_VEHICLE_NUMBER', type: 'input', paramKey: 'number', required: true, disabled: true },
  { title: 'Availability', tlabel: 'MDM_AVAILABILITY', paramKey: 'is_vehicle_available', required: true, disabled: false, type: 'switch', active_text: 'YES', inactive_text: 'NO' },
];

const shipmethod = [
  { title: 'Code', tlabel: 'MDM_CODE', type: 'input', paramKey: 'code', required: true },
  { title: 'Description', tlabel: 'MDM_DESCRIPTION', type: 'input', paramKey: 'description', required: true },
  {
    title: 'Default Regulation',
    tlabel: 'MDM_DEFAULT_REGULATION',
    type: 'dropdown',
    paramKey: 'regulation_code',
    options: regulationList,
    required: true,
  },
  { title: 'Caution Code', tlabel: 'MDM_CAUTION_CODE', type: 'input', paramKey: 'caution_codes', required: true, isArray: true },
  {
    title: 'Mode Of Transport',
    tlabel: 'MDM_MODE_OF_TRANSPORT',
    type: 'dropdown',
    paramKey: 'transport_code',
    options: transportationModeList,
    endGroup: true,
    required: true,
  },
  {
    title: 'Domestic Carrier',
    tlabel: 'MDM_DOMESTIC_COURIER',
    type: 'MultiSelectList',
    paramKey: 'domestic_carriers',
    options: [],
    required: true,
  },
  { title: 'Domestic Carrier Default', tlabel: 'MDM_DOMESTIC_COURIER_DEFAULT', type: 'dropdown', paramKey: 'domestic_carrier_default', options: [], optionKey: 'code', optionLabel: 'description', required: true },
  { title: 'International Carrier', tlabel: 'MDM_INTERNATIONAL_CARRIER', type: 'MultiSelectList', paramKey: 'international_carriers', options: [], required: true },
  { title: 'International Carrier Default', tlabel: 'MDM_INTERNATIONAL_CARRIER_DEFAULT', type: 'dropdown', paramKey: 'international_carrier_default', options: [], optionKey: 'code', optionLabel: 'description', required: true },
];

const transportationdb = [
  { title: 'Sku', type: 'input', tlabel: 'MDM_TRANSPORTATION_SKU', paramKey: 'sku', required: true, maxLength: 64 },
  { title: 'Transport Mode', tlabel: 'MDM_TRANSPORTATION_MODE', type: 'input', paramKey: 'transport_mode', required: true, maxLength: 16 },
  {
    title: 'Max Qty',
    type: 'input',
    tlabel: 'MDM_TRANSPORTATION_MAX_QTY',
    inputType: 'number',
    paramKey: 'max_qty',
    required: true,
    maxValue: 2147483647,
    minValue: 0,
  },
  { title: 'Category', type: 'input', tlabel: 'MDM_TRANSPORTATION_CATEGORY', paramKey: 'category', required: true, maxLength: 16 },
  {
    title: 'Pkg Detail',
    type: 'input',
    tlabel: 'MDM_TRANSPORTATION_PKG_DETAIL',
    paramKey: 'pkg_detail',
    required: true,
    maxLength: 2048,
  },
  {
    title: 'Vol',
    type: 'input',
    tlabel: 'MDM_TRANSPORTATION_VOL',
    paramKey: 'vol',
    inputType: 'number',
    required: true,
  },
  { title: 'Unit Of Measure', type: 'dropdown', tlabel: 'MDM_TRANSPORTATION_UNIT_OF_MEASURE', paramKey: 'uom', options: unitOfMeasure, required: true },
  { title: 'Service Code', type: 'input', tlabel: 'MDM_TRANSPORTATION_SERVICE_CODE', paramKey: 'service_code', required: false, maxLength: 64 },
  { title: 'Content ID', type: 'input', tlabel: 'MDM_TRANSPORTATION_CONTENT_ID', paramKey: 'content_id', required: false, maxLength: 64 },
  { title: 'Inner quantity', type: 'input', tlabel: 'MDM_TRANSPORTATION_INNER_QUANTITY', paramKey: 'inner_quantity', required: false, maxLength: 64 },
];

const transporter = [
  { title: 'Transporter Name', type: 'input', tlabel: 'MDM_TRANSPORTER_NAME', paramKey: 'name', required: true },
  { title: 'Reference Id', type: 'input', tlabel: 'MDM_REFERENCE_ID', paramKey: 'reference_id', required: true, isdependent: true },
  { title: 'Address', type: 'input', tlabel: 'MDM_ADDRESS', paramKey: 'address' },
  { title: 'City', type: 'input', tlabel: 'MDM_CITY', paramKey: 'city' },
  { title: 'State', type: 'input', paramKey: 'state', tlabel: 'MDM_STATE' },
  { title: 'Postal code', type: 'input', tlabel: 'MDM_PINCODE', inputType: 'numberOnly', paramKey: 'pincode', endGroup: true },
  { title: 'PAN Number', type: 'input', paramKey: 'pan_no', tlabel: 'MDM_PAN_NUMBER' },
  { title: 'GST Type', type: 'dropdown', tlabel: 'MDM_GST_TYPE', paramKey: 'gst_type', optionKey: 'id', optionLabel: 'name', required: true, options: gstList.slice(1) },
  { title: 'GST Percentage', type: 'input', tlabel: 'MDM_GST_PERCENTAGE', inputType: 'number', paramKey: 'gst_percentage', required: true },
  { title: 'Status', type: 'dropdown', tlabel: 'MDM_STATUS', paramKey: 'status', optionKey: 'id', optionLabel: 'name', required: true, options: statusList.slice(1) },
  { title: 'Discount(%)', type: 'input', tlabel: 'MDM_DISCOUNT_PER', inputType: 'number', paramKey: 'discount', feature: 'transporter_payment_discount', required: true, defaultValue: 0 },
  { title: 'Credit Period', type: 'input', tlabel: 'MDM_CREDIT_PERIOD', inputType: 'number', paramKey: 'credit_period', required: false },
  { title: 'MSME', type: 'dropdown', tlabel: 'MDM_MSME', paramKey: 'msme', optionKey: 'id', optionLabel: 'name', required: false, options: msmeOptions },
  { title: 'Generate LR', tlabel: 'MDM_GENERATE_LR', paramKey: 'generate_lr', required: false, feature: 'generate_lr', disabled: false, type: 'switch', active_text: 'YES', inactive_text: 'NO', defaultValue: false },
  { title: 'Auto Extend LR Series', tlabel: 'MDM_AUTO_EXTEND_LR_SERIES', paramKey: 'auto_extend_lr_series', required: true, feature: 'generate_lr', disabled: false, type: 'switch', active_text: 'YES', inactive_text: 'NO', defaultValue: true },
  {
    title: 'GSTIN',
    type: 'tableForm',
    tlabel: 'MDM_GSTIN',
    paramKey: 'gst',
    endGroup: true,
    subColumns: [
      { title: 'State', paramKey: 'state', tlabel: 'MDM_STATE', type: 'dropdown', required: true, optionKey: 'code', optionLabel: 'name', selectOnce: true },
      { title: 'GSTIN', paramKey: 'number', tlabel: 'MDM_GSTIN', type: 'input', required: true },
      { title: 'State Entity ID', tlabel: 'MDM_STATE_ENTITY_ID', paramKey: 'ref_id', type: 'input' },
      { title: 'Ack Number', tlabel: 'ACK_NO', paramKey: 'ack_no', type: 'input' },
      { title: 'Ack Date', tlabel: 'ACK_DATE', paramKey: 'ack_date', type: 'date' },
      { title: 'Address', tlabel: 'MDM_ADDRESS', paramKey: 'address', type: 'input', required: false },
    ],
  },
  {
    title: 'MANAGER',
    type: 'tableForm',
    tlabel: 'MDM_MANAGER',
    paramKey: 'users',
    required: true,
    endGroup: true,
    saveOnce: true,
    subColumns: [
      { title: 'Manager', tlabel: 'MDM_MANAGER', paramKey: 'name', type: 'input' },
      { title: 'Representative Mobile', tlabel: 'MDM_REPRESENTATIVE_MOBILE', paramKey: 'phone', type: 'input', inputType: 'number', max: 10 },
      { title: 'Representative Email', tlabel: 'MDM_REPRESENTATIVE_EMAIL', paramKey: 'email', type: 'input', required: true },
    ],
  },
  {
    title: 'ASSOCIATED DEPOTS',
    type: 'List',
    tlabel: 'MDM_TRANSPORTER_ASSOCIATED_DEPOTS',
    paramKey: 'depot_ids',
    options: [],
    required: false,
  },
];

const user = [

  { title: 'Status', type: 'switch', tlabel: 'MDM_STATUS', paramKey: 'status', active_text: 'ACTIVE', inactive_text: 'INACTIVE' },
  { title: 'User Name', type: 'input', tlabel: 'MDM_USER_NAME', paramKey: 'name', required: true },
  { title: 'Role', type: 'dropdown', tlabel: 'MDM_ROLE', paramKey: 'role_id', required: true },
  { title: 'Phone', type: 'input', paramKey: 'mobile', tlabel: 'MDM_PHONE', inputType: 'number', maxLength: 10 },
  { title: 'EMAIL ID', type: 'input', tlabel: 'MDM_EMAIL_ID', paramKey: 'email', required: true, dropdown: true, saveOnce: true },
  {
    title: 'USER PERMISSIONS',
    type: 'dropdown',
    tlabel: 'MDM_USER_PERMISSIONS',
    paramKey: 'notification_permission',
    options: [
      {
        id: 'INBOUND',
        name: 'INBOUND',
        tlabel: 'MDM_INBOUND',
        optionKey: 'INBOUND',
      },
      {
        id: 'OUTBOUND',
        title: 'OUTBOUND',
        tlabel: 'MDM_OUTBOUND',
        paramKey: 'OUTBOUND',
      },
      {
        id: 'BOTH',
        title: 'BOTH',
        tlabel: 'MDM_BOTH',
        paramKey: 'BOTH',
      },
    ],
    required: false,
  },
  // { title: 'USER PERMISSIONS', type: 'heading' },
  {
    title: 'DEPOT PERMISSION',
    type: 'List',
    tlabel: 'MDM_DEPOT_PERMISSION',
    paramKey: 'depot_ids',
    options: [],
    required: false,
  },
];
const billdiscount = [
  { title: 'Program ID', tlabel: 'MDM_PROGRAM_ID', type: 'input', paramKey: 'program_id', disabled: true },
  { title: 'Days Early', tlabel: 'MDM_DAYS_EARLY', type: 'input', paramKey: 'days_early', disabled: true },
  { title: 'Discount Rate (%)', tlabel: 'MDM_DISCOUNT_RATE', type: 'input', inputType: 'number', paramKey: 'discount_rate', required: true },
];

const transshipment = [
  {
    id: 'Source',
    title: 'Source',
    tlabel: 'MDM_SOURCE',
    type: 'dropdown',
    paramKey: 'depots',
    options: [],
    endGroup: true,
  },
  {
    id: 'Gate Ref ID',
    title: 'Gate Ref ID',
    tlabel: 'MDM_GATES',
    type: 'dropdown',
    paramKey: 'sourceRefId',
    options: [],
    endGroup: true,
    optionKey: 'id',
    optionLabel: 'reference_id',
  },
  { title: 'Status', type: 'dropdown', paramKey: 'status', optionKey: 'id', optionLabel: 'name', required: true, options: statusList.slice(1) },
  { title: 'Hub Type', type: 'dropdown', paramKey: 'hubType', optionKey: 'id', optionLabel: 'name', required: true, options: hubType.slice(1) },
  {
    id: 'Hubs',
    title: 'Hubs',
    tlabel: 'MDM_HUBS',
    type: 'MultiSelectList',
    paramKey: 'hubRefsList',
    options: [],
    endGroup: true,
    optionKey: 'reference_id',
    optionLabel: 'reference_id',
  }];

const packageMaster = [
  { title: 'Status', type: 'switch', paramKey: 'status', active_text: 'ACTIVE', inactive_text: 'INACTIVE', required: false },
  { title: 'Package ID', type: 'input', paramKey: 'package_id', disabled: false, required: true },
  { title: 'Description', type: 'input', paramKey: 'description', disabled: false, required: true },
  { title: 'Weight ( KG )', type: 'input', inputType: 'number', paramKey: 'weight', required: true },
  { title: 'Volume ( CFT )', type: 'input', inputType: 'number', paramKey: 'volume', required: true },
  { title: 'Length', type: 'input', inputType: 'number', paramKey: 'length', required: true },
  { title: 'Breadth', type: 'input', inputType: 'number', paramKey: 'breadth', required: true },
  { title: 'Height', type: 'input', inputType: 'number', paramKey: 'height', required: true },
  { title: 'Max stack', type: 'input', inputType: 'number', paramKey: 'max_stack', required: false },
  { title: 'Weight capacity', type: 'input', inputType: 'number', paramKey: 'weight_capacity', required: false },
  { title: 'Volume capacity', type: 'input', inputType: 'number', paramKey: 'volume_capacity', required: false },
  {
    title: 'Type',
    type: 'dropdown',
    paramKey: 'type',
    options: [
      {
        id: 'BINS',
        name: 'BINS',
        optionKey: 'BINS',
      },
      {
        id: 'TROLLEYS',
        title: 'TROLLEYS',
        paramKey: 'TROLLEYS',
      },
      {
        id: 'CORRUGATED_BOX',
        title: 'CORRUGATED_BOX',
        paramKey: 'CORRUGATED_BOX',
      },
      {
        id: 'PALLETS',
        title: 'PALLETS',
        paramKey: 'PALLETS',
      },
    ],
    required: true,
  },
  {
    title: 'Load type',
    type: 'dropdown',
    paramKey: 'load_type',
    options: [
      {
        id: 1,
        name: 'Quantity',
        optionKey: 1,
      },
      {
        id: 2,
        name: 'Weight',
        optionKey: 2,
      },
      {
        id: 3,
        name: 'Fitment',
        optionKey: 3,
      },
    ],
    required: true,
  },
  { title: 'Can load on top', type: 'switch', paramKey: 'can_load_on_top', active_text: 'Yes', inactive_text: 'No', required: false },
];

const freightZone = [
  { id: 0, title: 'Name', tlabel: 'MDM_NAME', type: 'input', paramKey: 'name', disabled: false, required: true },
  { id: 1, type: 'break' },
  { id: 1, type: 'heading', title: 'Pincodes' },
  { id: 2, title: 'Pincodes', tlabel: 'MDM_PINCODES', type: 'array', paramKey: 'pincodes', itemKey: 'pincode', inputType: 'number', disabled: false, required: true },
];

const legalEntity = [
  { id: 0, title: 'Legal Entity Code', tlabel: 'LEGAL_ENTITY_CODE', type: 'input', paramKey: 'legal_entity_code', disabled: false, required: true },
  { id: 1, title: 'Company Name', tlabel: 'FREIGHT_INVOICE_COMPANY_NAME', type: 'input', paramKey: 'company_name', disabled: false, required: true },
  { id: 2, title: 'Company GSTIN', tlabel: 'FREIGHT_INVOICE_COMPANY_GSTIN', type: 'input', paramKey: 'gstin', disabled: false, required: true },
  { id: 3, title: 'Company Address', tlabel: 'FREIGHT_INVOICE_COMPANY_ADDRESS', type: 'input', paramKey: 'address', disabled: false, required: true },
  { id: 4, title: 'Company City', tlabel: 'FREIGHT_INVOICE_COMPANY_CITY', type: 'input', paramKey: 'city', disabled: false, required: true },
  { id: 5, title: 'Company State', tlabel: 'FREIGHT_INVOICE_COMPANY_STATE', type: 'input', paramKey: 'state', disabled: false, required: true },
  { id: 6, title: 'Company Pincode', tlabel: 'FREIGHT_INVOICE_COMPANY_PINCODE', type: 'input', paramKey: 'pincode', inputType: 'number', disabled: false, required: true },
  { id: 7, title: 'LR Document Company Name', tlabel: 'LR_DOCUMENT_COMPANY_NAME', type: 'input', paramKey: 'lr_document_company_name', disabled: false, required: true  },
  { id: 8, title: 'LR Document Company GSTIN', tlabel: 'LR_DOCUMENT_COMPANY_GSTIN',type: 'input',paramKey: 'lr_document_company_gstin', disabled: false, required: true},
  { id: 9, title: 'LR Document Company Address', tlabel: 'LR_DOCUMENT_COMPANY_ADDRESS',type: 'input',paramKey: 'lr_document_company_address', disabled: false, required: true},
  { id: 10, title: 'LR Document Company City', tlabel: 'LR_DOCUMENT_COMPANY_CITY',type: 'input',paramKey: 'lr_document_company_city', disabled: false, required: true},
  { id: 11, title: 'LR Document Company State', tlabel: 'LR_DOCUMENT_COMPANY_STATE',type: 'input',paramKey: 'lr_document_company_state', disabled: false, required: true},
  { id: 12, title: 'LR Document Company Pincode', tlabel: 'LR_DOCUMENT_COMPANY_PINCODE',type: 'input',paramKey: 'lr_document_company_pincode', inputType: 'number', disabled: false, required: true},

];

const vehicle = [
  { title: 'Vehicle Name', tlabel: 'MDM_VEHICLE_NAME', type: 'input', inputType: 'text', paramKey: 'short_form', disabled: false, required: true },
  { title: 'CFT', tlabel: 'MDM_CFT', type: 'input', inputType: 'number', paramKey: 'cft', disabled: false, required: true, defaultValue: 0 },
  { title: 'KG', tlabel: 'MDM_KG', type: 'input', inputType: 'number', paramKey: 'kg', disabled: false, required: true, defaultValue: 0 },
  { title: 'Vehicle Weightage', tlabel: 'Vehicle Weightage', type: 'input', inputType: 'number', paramKey: 'weightage', disabled: false, required: false, defaultValue: 1 },
  { title: 'Vehicle Type', tlabel: 'Vehicle Type', type: 'dropdown', paramKey: 'vehicle_type', disabled: false, required: true, optionKey: 'name', optionLabel: 'name', options: deliveryList },
  { title: 'Fuel Type', tlabel: 'MDM_FUEL_TYPE', type: 'dropdown', paramKey: 'fuel_type', disabled: false, required: true, optionKey: 'id', optionLabel: 'name', options: fuelList, endGroup: true },
  { title: 'Excluded Categories', tlabel: 'MDM_EXCLUDED_MATERIAL_CATEGORIES', type: 'input', inputType: 'text', paramKey: 'exclude_sku_categories', disabled: false, required: false },
  { title: 'Length Factor', tlabel: 'MDM_LENGTH_FACTOR', type: 'input', paramKey: 'length_factor', inputType: 'number', disabled: false, required: false, defaultValue: 1 },
  { title: 'Breadth Factor', tlabel: 'Breadth Factor', type: 'input', paramKey: 'breadth_factor', inputType: 'number', disabled: false, required: false, defaultValue: 1 },
  { title: 'Height Factor', tlabel: 'Height Factor', type: 'input', paramKey: 'height_factor', inputType: 'number', disabled: false, required: false, defaultValue: 1 },
  { title: 'Length', tlabel: 'MDM_LENGTH', type: 'input', paramKey: 'length', inputType: 'number', disabled: false, required: false, defaultValue: 0 },
  { title: 'Breadth', tlabel: 'Breadth', type: 'input', paramKey: 'breadth', inputType: 'number', disabled: false, required: false, defaultValue: 0, endGroup: true },
  { title: 'Height', tlabel: 'Height', type: 'input', paramKey: 'height', inputType: 'number', disabled: false, required: false, defaultValue: 0 },
  { title: 'Description', tlabel: 'MDM_DESCRIPTION', type: 'input', paramKey: 'description', inputType: 'text', disabled: false, required: false },
  { title: 'Max Distance', tlabel: 'MDM_MAX_DISTANCE', type: 'input', paramKey: 'max_distance', inputType: 'number', disabled: false, required: false, defaultValue: 0 },
  {

    title: 'Mode',
    tlabel: 'Mode',
    type: 'dropdown',
    paramKey: 'mode',
    disabled: false,
    required: false,
    optionKey: 'id',
    optionLabel: 'name',
    options: Object.entries(vehicleTypeMode).map(([name, key]) => ({
      id: vehicleTypeMode[name],
      name,
      key,
    })),
  },
  { title: 'Carbon Emission Factor', tlabel: 'MDM_CARBON_EMISSION_FACTOR', type: 'input', paramKey: 'carbon_emission_factor', inputType: 'number', disabled: false, required: false },
  { title: 'Eligible Open Indent', tlabel: 'MDM_OPEN_ELIGIBLE', type: 'switch', paramKey: 'is_open_eligible', disabled: false, required: false, active_text: 'MDM_YES', inactive_text: 'MDM_NO' },
  { title: 'Seal Available', tlabel: 'MDM_SEAL_AVAILABLE', type: 'switch', paramKey: 'seal_available', disabled: false, required: false, active_text: 'MDM_YES', inactive_text: 'MDM_NO', endGroup: true },
];


// eslint-disable-next-line import/prefer-default-export
export const formConstants = {
  port,
  cha,
  container,
  freightforwarder,
  carton,
  carrier,
  shipmethod,
  transportationdb,
  transporter,
  vehicledetail,
  billdiscount,
  user,
  transshipment,
  package_master: packageMaster,
  freight_zone: freightZone,
  legal_entity: legalEntity,
  vehicle,
};
